import { useCreateLeadNote } from '@/api/leads/notes/createLeadNote';
import { FormTextarea } from '@/components/Form';
import { Button } from '@/components/ui/elements/button';
import { Form } from '@/components/ui/form/form';
import { Lead } from '@/types';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const schema = z.object({
  message: z.string().min(3, 'Required'),
});

type NewNoteFormProps = {
  lead: Lead;
  className?: string;
};

export const NewNoteForm = ({ lead, className = '' }: NewNoteFormProps) => {
  const { mutate: addNote } = useCreateLeadNote();

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: { message: '' },
  });

  const handleAddNote = (data: z.infer<typeof schema>) => {
    addNote(
      {
        data: { lead_id: lead.id, message: data.message },
      },
      {
        onSuccess: () => form.reset(),
      },
    );
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleAddNote)} className={className}>
        <div className="flex flex-col bg-background  border rounded-md">
          <div className="relative">
            <FormTextarea
              control={form.control}
              name="message"
              className="h-24 border-0 shadow-none"
              placeholder="Enter notes here..."
            />
            <div className="absolute bottom-2 right-2">
              <Button type="submit" size="sm" variant="outline" disabled={!form.formState.isValid}>
                Add Note
              </Button>
            </div>
          </div>
        </div>
      </form>
    </Form>
  );
};
